import React, { useEffect, useState } from "react";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import {
  useAddCouponCredentialForTenantMutation,
  useUpdateCouponCredentialForTenantMutation,
} from "../../../features/tenant/couponCredential/couponCredentialApi";
import { toast } from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";

const providerArray = [
  {
    id: 1,
    name: "prepaidocean",
    form: {
      name: ["client_id", "client_secret"],
      view_name: ["Client Id", "Client Secret"],
    },
  },
  {
    id: 2,
    name: "qwikcilver",
    form: {
      name: ["username", "password", "url"],
      view_name: ["Username", "Password", "Url"],
    },
  },
];

const AddCouponCredential = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isUpdate, setIsUpdate] = useState(
    location?.state?.edit ? true : false
  );

  const [selectCredType, setSelectCredType] = useState(
    isUpdate ? Number(location.state.form.id) - 1 : 0
  );
  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (isUpdate) {
      let temp = {};
      location &&
        location?.state?.form.form.name.map((x) => {
          temp[x] = location.state.data.api_credential[x];
        });
      setFormData({ ...temp });
    }
  }, [location, isUpdate]);

  const [
    addCouponCredentialForTenant,
    {
      data: addCouponCredentialForTenantData,
      isError: addCouponCredentialForTenantIsError,
      error: addCouponCredentialForTenantError,
      isLoading: addCouponCredentialForTenantIsLoading,
    },
  ] = useAddCouponCredentialForTenantMutation();

  const [
    updateCouponCredentialForTenant,
    {
      data: updateCouponCredentialForTenantData,
      isError: updateCouponCredentialForTenantIsError,
      error: updateCouponCredentialForTenantError,
      isLoading: updateCouponCredentialForTenantIsLoading,
    },
  ] = useUpdateCouponCredentialForTenantMutation();

  const handleAddCouponCredential = (e) => {
    e.preventDefault();
    let allFieldAdded = false;

    for (const [key, value] of Object.entries(formData)) {
      if (value === null || value === "") {
        allFieldAdded = true;
      }
    }
    if (
      allFieldAdded ||
      Object.keys(formData).length <
        providerArray[selectCredType].form.name.length
    ) {
      toast.error("Please Enter all fields", {
        id: "field_error",
      });
      return;
    }

    let apiCredential = {};
    for (const [key, value] of Object.entries(formData)) {
      apiCredential[key] = value;
    }

    addCouponCredentialForTenant({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        api_credential: apiCredential,
        type: providerArray[selectCredType].name,
      },
    });
  };

  if (addCouponCredentialForTenantIsError) {
    toast.dismiss();
    toast.error("Some Error Occurred", {
      id: "addCouponCredentialIsError",
    });
  }

  if (addCouponCredentialForTenantIsLoading) {
    toast.dismiss();
    toast.loading("Loading...", {
      id: "addCouponCredentialIsLoading",
    });
  }

  useEffect(() => {
    if (addCouponCredentialForTenantData) {
      toast.dismiss();
      toast.success(`${addCouponCredentialForTenantData.message}`, {
        id: `addCouponCredentialSuccess`,
      });
      navigate(-1);
    }
    if (addCouponCredentialForTenantError) {
      toast.dismiss();
      toast.error(
        addCouponCredentialForTenantError.data?.message || "Error occurred",
        {
          id: `addCouponCredentialError`,
        }
      );
    }
  }, [addCouponCredentialForTenantData, addCouponCredentialForTenantError]);

  const handleUpdate = (e) => {
    e.preventDefault();
    let allFieldAdded = false;

    for (const [key, value] of Object.entries(formData)) {
      if (value === null || value === "") {
        allFieldAdded = true;
      }
    }
    if (
      allFieldAdded ||
      Object.keys(formData).length <
        providerArray[selectCredType].form.name.length
    ) {
      toast.error("Please Enter all fields", {
        id: "field_error",
      });
      return;
    }

    let apiCredential = {};
    for (const [key, value] of Object.entries(formData)) {
      apiCredential[key] = value;
    }

    updateCouponCredentialForTenant({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      id: location.state.data.id,
      body: {
        api_credential: apiCredential,
        type: providerArray[selectCredType].name,
      },
    });
  };

  useEffect(() => {
    if (updateCouponCredentialForTenantData) {
      toast.dismiss();
      toast.success(`${updateCouponCredentialForTenantData.message}`, {
        id: `updateCouponCredentialSuccess`,
      });
      navigate(-1);
    }
    if (updateCouponCredentialForTenantError) {
      toast.dismiss();
      toast.error(
        updateCouponCredentialForTenantError.data?.message || "Error occurred",
        {
          id: `updateCouponCredentialError`,
        }
      );
    }
  }, [updateCouponCredentialForTenantData, updateCouponCredentialForTenantError]);

  return (
    <>
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            {isUpdate ? "Update " : "Add "}
            Coupon Credential
            <LinksComponent />
          </div>
          <div className="p-3">
            <form className="p-3 bg-white shadow rounded-lg">
              <div className="w-full flex justify-center space-x-3">
                <div className="mb-6 w-1/4">
                  <div className="w-full">
                    <label className="block text-sm font-medium leading-6 text-gray-900 mb-0">
                      Type
                    </label>
                    <select
                      className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm h-auto rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                      value={selectCredType}
                      disabled={isUpdate}
                      onChange={(e) =>
                        setSelectCredType(Number(e.target.value))
                      }
                    >
                      {providerArray &&
                        providerArray.map((x, index) => {
                          return (
                            <option key={x.id} value={Number(index)}>
                              {x.name}
                            </option>
                          );
                        })}
                    </select>
                  </div>
                </div>

                {providerArray &&
                  providerArray.length > 0 &&
                  providerArray[Number(selectCredType)]?.form?.name.map(
                    (x, index) => {
                      return (
                        <div key={index} className="mb-6 w-1/4">
                          <div className="w-full">
                            <label
                              className="block text-sm font-medium leading-6 text-gray-900 mb-0"
                              htmlFor={x}
                            >
                              {
                                providerArray[selectCredType]?.form.view_name[
                                  index
                                ]
                              }
                            </label>
                            <input
                              name={x}
                              id={x}
                              className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                              value={
                                Object.keys(formData).length > 0
                                  ? formData[x] || ""
                                  : ""
                              }
                              onChange={(e) => {
                                let data = {};
                                data[e.target.name] = e.target.value;
                                setFormData({ ...formData, ...data });
                              }}
                              type="text"
                            />
                          </div>
                        </div>
                      );
                    }
                  )}
              </div>
              <div className="flex justify-center mt-2">
                {isUpdate ? (
                  <button
                    type="button"
                    onClick={(e) => handleUpdate(e)}
                    className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                  >
                    Update
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={handleAddCouponCredential}
                    className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                  >
                    Add
                  </button>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCouponCredential;
